import styled from 'styled-components';
import { DetailDataProps } from '../data';
import { t } from '../../detail/components/Table.styles';
import { useState } from 'react';
import { DetailNoDataColumn } from '../../components/nodata/NoData';
interface Props {
  data: DetailDataProps;
}

const PartiesDetail = ({ data }: Props) => {
  const [showAll, setShowAll] = useState(false);
  return (
    <Container id="당사자내역">
      <div>당사자내역</div>
      <t.Table>
        <thead>
          <t.Row>
            <t.TableHeadTh width="auto">당사자구분</t.TableHeadTh>
            <t.TableHeadTh width="auto">당사자명</t.TableHeadTh>
            <t.TableHeadTh width="auto">당사자구분</t.TableHeadTh>
            <t.TableHeadTh width="auto">당사자명</t.TableHeadTh>
          </t.Row>
        </thead>
        <tbody>
          {data.party_history.length === 0 && (
            <DetailNoDataColumn absorption={4} />
          )}
          {data.party_history.length > 0 &&
            data.party_history
              .slice(0, showAll ? data.party_history.length : 4)
              .map((data, index) => (
                <t.Row key={index}>
                  {data.map((item, idx) => (
                    <t.ContentCell
                      key={idx}
                      width="auto"
                      textAlign="center"
                      border={true}
                    >
                      {item}
                    </t.ContentCell>
                  ))}
                </t.Row>
              ))}
        </tbody>
      </t.Table>
      {data.party_history.length > 4 && (
        <MoreButton
          onClick={() => {
            setShowAll((prev) => !prev);
          }}
        >
          <div>{showAll ? '닫기' : '더보기'}</div>
          <img
            style={{
              transform: showAll ? 'rotate(180deg)' : 'rotate(0deg)',
            }}
            src="/assets/images/arrow/Arrow_down.png"
            alt=""
          />
        </MoreButton>
      )}
    </Container>
  );
};

export default PartiesDetail;

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 32px 16px;
  background-color: #fff;
  gap: 24px;
  color: #222222;
  font-size: 18px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 700;
  line-height: 26.1px;
  word-wrap: break-word;
`;

const MoreButton = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  padding: 12px 16px;
  gap: 4px;
  color: black;
  font-size: 13px;
  font-family: Spoqa Han Sans Neo;
  font-weight: 400;
  line-height: 18.85px;
  word-wrap: break-word;
  border-radius: 4px;
  border: 1px #e1e2e4 solid;

  img {
    width: 16px;
    height: 16px;
  }
`;
